var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgWrong(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.9345 23.0809L19.4148 14.5461L27.9345 6.01132C28.6052 5.36858 28.9893 4.48212 28.9998 3.55249C29.0101 2.62264 28.6462 1.72784 27.99 1.0701C27.3341 0.412363 26.4411 0.0473175 25.5129 0.0572023C24.5847 0.0670801 23.6998 0.451184 23.0577 1.12263L14.5346 9.6735L5.90888 1.01631C5.03494 0.140131 3.76075 -0.202215 2.5663 0.11789C1.37191 0.438012 0.438775 1.37233 0.118321 2.56867C-0.202134 3.76501 0.138937 5.04164 1.01291 5.91782L9.65474 14.5618L1.1156 23.1029C0.468893 23.7507 0.105642 24.6294 0.105642 25.5456C0.105642 26.4617 0.468893 27.3403 1.1156 27.9882C1.7623 28.6361 2.63939 29 3.55394 29C4.46849 29 5.34553 28.6361 5.99229 27.9882L14.5182 19.4471L23.0379 27.9854C23.9197 28.8236 25.1757 29.1375 26.3473 28.812C27.5186 28.4864 28.434 27.5694 28.759 26.396C29.0839 25.2224 28.7706 23.9641 27.9338 23.0807L27.9345 23.0809Z",
    fill: "white"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWrong);
export default __webpack_public_path__ + "static/media/wrong.7dc3e6fd2cb5a6ce196e5f1cbfb45745.svg";
export { ForwardRef as ReactComponent };